<template>
  <div class="max-w-[800px] w-full">
    <div class="flex flex-wrap md:flex-nowrap justify-between mb-4 gap-4">
      <MembersNavigation />
      <Protect :permissions="[SYS_PERMISSIONS.SYS_MEMBERSHIPS_MANAGE]">
        <InvitationMemberDialog />
      </Protect>
    </div>
    <MembersTable />
  </div>
</template>

<script setup>
import Protect from '@/hoc/Protect.vue';
import { SYS_PERMISSIONS } from '@/constants.js';
import InvitationMemberDialog from './components/members/InvitationMemberDialog.vue';
import MembersNavigation from './components/members/MembersNavigation.vue';
import MembersTable from './components/MembersTable.vue';
</script>
